/* eslint-disable react/display-name */
import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Divider, Dropdown, Row, Space } from 'antd'
import {
  formatDateTime,
  formatDateWithoutTime,
  getMenuTypeName,
  getReturnOrderStatus,
  getSupplierInvoiceStatus,
  numberWithComma,
} from 'helpers/format'
import { selectSupplierInvoiceActionEvent } from 'Store/supplier-invoice/selector'
import { selectCurrentUser } from 'Store/user/selector'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import theme, { MyTheme } from 'Components/common/Theme'
import BillingNotePDF from './components/BillingNotePDF'
import ReactToPrint from 'react-to-print'
import { PrimaryButton } from 'Components/button'
import { PrinterOutlined } from '@ant-design/icons'
import { TableListPage } from 'Components/common/Table'
import { getSupplierBillDetailAPI } from 'Store/supplier-bill/api'
import { SupplierBillDetailReq, SupplierBillItem } from 'Store/supplier-bill/types'
import { selectSupplierBillDetail, selectSupplierBillDetailEvent } from 'Store/supplier-bill/selector'
import { InfoItem } from 'Pages/Orders/components'
import SupplierOrderDetail from '../SupplierInvoice/detail'
import { MenuPrints } from 'Components/form'
import { menuReturnPaymentTypes } from 'helpers/constanst'
import { StatusTag } from 'Components/utilities'
import { ReturnData } from 'Store/return-order/types'
import ReturnDetail from '../OrderReturns/detail'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  onPaymentSuccess?: () => void
  id?: number
}

const QuotationDetail: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, currentUser, id = 0, detail, detailEvent } = props
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [returnDetailDrawer, setReturnDetailDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)

  const dispatch = useDispatch()
  const billingNotesePDF = useRef(null as any)
  const billingNoteseLitePDF = useRef(null as any)

  useEffect(() => {
    if (visible) {
      onGetDetail()
    }
  }, [visible, id])

  const onGetDetail = (): void => {
    const req: SupplierBillDetailReq = {
      id,
    }
    dispatch(getSupplierBillDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onClickViewDetail = (id: number) => {
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const onOpenReturnDetailDrawer = () => {
    setReturnDetailDrawer(true)
  }

  const onCloseReturnDetailDrawer = () => {
    setReturnDetailDrawer(false)
  }

  const onClickViewReturnDetail = (id: number) => {
    setSelectedID(id)
    onOpenReturnDetailDrawer()
  }

  const SupplierOrdeDetailDrawer = (
    <SupplierOrderDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={() => {
        onGetDetail()
      }}
      viewMode={false}
    />
  )

  const ReturnOrderDetailDrawer = (
    <ReturnDetail
      id={selectedID}
      visible={returnDetailDrawer}
      onCloseDrawer={onCloseReturnDetailDrawer}
      onSuccess={() => {
        onGetDetail()
      }}
      onPaymentSuccess={() => {
        onGetDetail()
      }}
    />
  )

  const columns = [
    {
      title: 'เลขที่สั่งซื้อ',
      dataIndex: 'sale_order_no',
      key: 'sale_order_no',
      width: '180px',
      render: (val: string, record: SupplierBillItem) => (
        <LinkNo onClick={() => onClickViewDetail(record.sale_order_id)}>{val}</LinkNo>
      ),
    },
    // {
    //   title: 'เลขที่ใบเสนอราคา',
    //   dataIndex: 'quotation_no',
    //   key: 'quotation_no',
    //   width: '180px',
    // },
    {
      title: 'วันที่สั่งซื้อ',
      dataIndex: 'order_date',
      key: 'order_date',
      render: (val: string) => formatDateTime(val),
    },
    {
      title: 'วันที่ครบกำหนดชำระ',
      dataIndex: 'expiry_dt',
      key: 'expiry_dt',
      render: (val: string) => (val ? formatDateWithoutTime(val) : '-'),
    },
    // {
    //   title: 'วันที่จัดส่ง',
    //   dataIndex: 'delivered_date',
    //   key: 'delivered_date',
    //   render: (val: string) => formatDateTime(val),
    // },
    {
      title: 'ยอดสั่งซื้อ',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (val: number) => numberWithComma(val, true),
      align: 'right',
    },
    {
      title: 'ยอดชำระ',
      dataIndex: 'total_paid',
      key: 'total_paid',
      render: (val: number) => numberWithComma(val, true),
      align: 'right',
    },
    {
      title: 'ยอดค้างชำระ',
      dataIndex: 'total_remain',
      key: 'total_remain',
      render: (val: number) => numberWithComma(val, true),
      align: 'right',
    },
  ]

  const renderStatus = (status: string) => {
    const statusResult = getReturnOrderStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const columnsReturn = [
    {
      title: 'เลขที่สั่งซื้อ',
      dataIndex: 'sale_order_no',
      key: 'sale_order_no',
      width: '180px',
      render: (val: string, record: SupplierBillItem) => (
        <LinkNo onClick={() => onClickViewReturnDetail(record.sale_order_id)}>{val}</LinkNo>
      ),
    },
    {
      title: 'วันที่รับคืนสินค้า',
      dataIndex: 'order_date',
      key: 'order_date',
      width: '200px',
      render: (val: string) => formatDateTime(val || ''),
    },
    {
      title: 'ยอดลดหนี้สุทธิ',
      dataIndex: 'total_amount',
      key: 'total_amount',
      align: 'right',
      render: (val: number) => {
        return numberWithComma(val, true)
      },
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      width: '30px',
    },
    // {
    //   title: 'ช่องทางการคืนเงิน',
    //   dataIndex: 'return_type',
    //   key: 'return_type',
    //   render: (return_type: string) => getMenuTypeName(menuReturnPaymentTypes, return_type || ''),
    // },
    // {
    //   title: 'รับคืนโดย',
    //   dataIndex: 'officer',
    //   key: 'officer',
    // },
    {
      title: 'สถานะการคืนเงิน',
      dataIndex: 'status',
      key: 'status',
      width: '250px',
      align: 'right',
      render: renderStatus,
    },
  ]

  const renderTitle = () => {
    return (
      <Row justify="start" gutter={[8, 8]} align="top">
        <Col>
          <Space direction="vertical" size="small">
            <Space size="small" wrap={true}>
              {`เลขที่ใบวางบิล : ${detail?.billing_note_no}`}
            </Space>
            <Space size="small" wrap={true}>
              <SmallText>วันที่ออกใบวางบิล : {formatDateTime(detail?.created_at || '')}</SmallText>
            </Space>
          </Space>
        </Col>
      </Row>
    )
  }

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={null}
      width={'90%'}
      maskClosable={true}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={24} xs={24}>
          <BoxWrapper>
            <BoxTitle>ข้อมูลลูกค้า/คู่ค้า</BoxTitle>
            <Row>
              <Col md={12} xs={24}>
                {renderInfo('ชื่อ', detail?.name)}
                {renderInfo('ที่อยู่', detail?.address)}
                {renderInfo('เบอร์โทรศัพท์', detail?.mobile)}
                {renderInfo('อีเมล', detail?.email)}
              </Col>
              <Col md={12} xs={24}>
                {renderInfo('หมายเหตุ', detail?.remark)}
              </Col>
            </Row>
          </BoxWrapper>
        </Col>
        <Col md={24} xs={24}>
          <BoxWrapper>
            <Row justify="end" gutter={[16, 8]}>
              <Col>
                <Space>
                  <Dropdown
                    key="more"
                    overlay={
                      <MenuPrints
                        nomalPrintRef={billingNotesePDF}
                        litePrintRef={billingNoteseLitePDF}
                        title={`ใบแจ้งหนี้/ใบวางบิล-${detail?.billing_note_no}`}
                      />
                    }
                    trigger={['click', 'hover']}
                  >
                    <PrimaryButton
                      btnType="Approve"
                      text="พิมพ์ใบวางบิล"
                      icon={<PrinterOutlined />}
                      onClick={() => {}}
                      size="middle"
                    />
                  </Dropdown>
                </Space>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <BoxTitle>รายการออกใบวางบิล</BoxTitle>
              </Col>
              <Col span={24}>
                <TableListPage
                  columns={columns}
                  datas={detail?.items || []}
                  isLoading={false}
                  paginationContent={null}
                  size="middle"
                  scrollX={800}
                />
              </Col>
              <Col span={24}>
                <Row justify="space-between" align="middle" gutter={[32, 8]}>
                  <Col>
                    <Space>จำนวน {numberWithComma(detail?.items?.length)} รายการ</Space>
                  </Col>
                  <Col>
                    <Space>
                      จำนวนเงิน
                      <GreenText>
                        {numberWithComma((detail?.total_amount || 0) - (detail?.total_paid || 0), true)}
                      </GreenText>
                      บาท
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>
            {detail?.void_items && detail?.void_items.length > 0 && (
              <>
                <Divider />
                <Row>
                  <Col span={24}>
                    <BoxTitle>รายการคืนสินค้า/ลดหนี้</BoxTitle>
                  </Col>
                  <Col span={24}>
                    <TableListPage
                      columns={columnsReturn}
                      datas={detail?.void_items || []}
                      isLoading={false}
                      paginationContent={null}
                      size="middle"
                      scrollX={800}
                    />
                  </Col>
                  <Col span={24}>
                    <Row justify="space-between" align="middle" gutter={[32, 8]}>
                      <Col>
                        <Space>จำนวน {numberWithComma(detail?.items?.length)} รายการ</Space>
                      </Col>
                      <Col>
                        <Space>
                          จำนวนเงิน
                          <RedText>{numberWithComma(detail?.total_void || 0, true)}</RedText> บาท
                        </Space>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            )}
          </BoxWrapper>
        </Col>
      </Row>
      <SumWrapper>
        <Row justify="end" align="middle" gutter={[32, 8]}>
          <Col span={24}>
            <Row justify="end" gutter={[32, 8]}>
              <Col md={8} xs={12}>
                รวม รายการออกใบวางบิลทั้งหมด
              </Col>
              <Col md={4} xs={12} style={{ textAlign: 'right' }}>
                <GreenText>
                  {numberWithComma((detail?.total_amount || 0) - (detail?.total_paid || 0), true)}
                </GreenText>{' '}
                บาท
              </Col>
            </Row>
            <Row justify="end" gutter={[32, 8]}>
              <Col md={8} xs={12}>
                หัก รายการคืนสินค้า/ลดหนี้
              </Col>
              <Col md={4} xs={12} style={{ textAlign: 'right' }}>
                <RedText>{numberWithComma(detail?.total_void || 0, true)}</RedText> บาท
              </Col>
            </Row>
            <Divider />
            <Row justify="end" gutter={[32, 8]} align="bottom">
              <Col md={8} xs={12}>
                รวมเงินทั้งสิ้น
              </Col>
              <Col md={4} xs={12} style={{ textAlign: 'right' }}>
                <Price>{numberWithComma(detail?.total_remain, true)} </Price>บาท
              </Col>
            </Row>
          </Col>
        </Row>
      </SumWrapper>
      {SupplierOrdeDetailDrawer}
      {ReturnOrderDetailDrawer}
      <Row ref={billingNotesePDF}>
        <Col span={24}>
          <BillingNotePDF detail={detail} />
        </Col>
      </Row>
      <Row ref={billingNoteseLitePDF}>
        <Col span={24}>
          <BillingNotePDF detail={detail} isLite={true} />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const SmallText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Price = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`

const SumWrapper = styled.div`
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  padding: 10px 20px;
  border-radius: 5px;
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

const GreenText = styled.span`
  color: green;
`

const RedText = styled.span`
  color: red;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectSupplierInvoiceActionEvent(state),
    detail: selectSupplierBillDetail(state),
    detailEvent: selectSupplierBillDetailEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(QuotationDetail)
